module.exports = __webpack_public_path__ + "img/zhAward-b.0c8e4f51.png";